import styled from '@emotion/styled'

export const ReceiptsRightActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
`
